import breakPoints from "helpers/Styles";

const TwoColumnsTab = ({ block, defaultBackgroundColor, primaryFontColor, secondaryFontColor }) => {
  if (!block) return "";

  const {
    image,
    image_position,
    subtitle,
    contents,
    column_title,
    background_colour,
    column_title_colour,
    subtitle_colour,
    contents_colour,
  } = block.primary;
  const imageUrl = image ? image.url : null;
  const subTitle = subtitle ? subtitle : null;
  const columnTitle = column_title ? column_title : null;
  const backgroundColour = background_colour ? background_colour : defaultBackgroundColor;
  const columnTitleColour = column_title_colour
    ? column_title_colour
    : primaryFontColor;
  const subtitleColour = subtitle_colour ? subtitle_colour : primaryFontColor;
  const contentsColour = contents_colour ? contents_colour : secondaryFontColor;

  const { items } = block;

  const applyHyperLinks = (content) => {
    let text = content.text;
    if (content?.spans) {
      const linkSpans = content?.spans?.filter(
        (span) => span.type === "hyperlink"
      );
      const descending = linkSpans?.sort((a, b) => b.start - a.start);
      descending?.map((span) => {
        text =
          text.substring(0, span.start - 1) +
          "<a target='_blank' style='margin:0 4px;color:#fd0300;' href='" +
          span.data.url +
          "'>" +
          text.substring(span.start, span.end) +
          "</a>" +
          text.substring(span.end + 1, text.length);
      });
    }
    return text;
  };
  return (
    <>
      <div className="two_columns wrapper">
        <div
          className={`two_column_container ${
            image_position === 'left' ? '' : 'content_reverse'
          }`}
        >
          <div className="image_column">
            <img draggable="false"  src={imageUrl} alt={columnTitle} />
          </div>
          <div className="information_column">
            <div className="icons_logos">
              {items &&
                items.map((item, index) => item.icon_logo.url && (
                  <img draggable="false"  src={item.icon_logo.url} alt="icon_logo" key={index} />
                ))}
            </div>
            <div className="information_content">
              <h1 className="column_title">{columnTitle}</h1>
              <h3 className="subtitle">{subTitle}</h3>
              {contents.map((item, index) => {
                const res = applyHyperLinks(item);
                if (item.spans && item.spans.length > 0) {
                  return (
                    <p
                      key={index}
                      dangerouslySetInnerHTML={{
                        __html: res,
                      }}
                    />
                  );
                } else {
                  return <p key={index}>{item.text}</p>;
                }
              })}
            </div>
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .two_columns {
            padding: 40px;
            background: ${backgroundColour};
            color: white;
          }
          .two_column_container {
            display: flex;
          }
          .content_reverse {
            flex-direction: row-reverse;
          }
          .image_column {
            width: 50%;
            height: 100%;
          }
          .image_column img {
            width: 100%;
          }
          .icons_logos img {
            height: 60px;
            margin-right: 15px;
          }
          .information_column {
            width: 50%;
            padding: 60px 80px;
          }
          .information_content {
            margin-top: 50px;
          }
          .subtitle {
            color: ${subtitleColour};
            font-family: 'big_noodle_titling';
            font-size: 31px;
            letter-spacing: 0;
            line-height: 30px;
            margin: 0;
          }
          .information_column h1 {
            font-size: 39px;
            width: 100%;
            color: ${columnTitleColour};
            font-size: 39px;
            letter-spacing: 0;
            line-height: 48px;
            font-family: 'big_noodle_titling';
          }
          .information_column p {
            width: 100%;
            color: ${contentsColour};
            font-family: 'Roboto-Medium';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
            margin-bottom: 20px;
          }

          @media (max-width: ${breakPoints.large}) {
            .information_column {
              padding: 0px 80px;
            }
            .information_content p,
            .information_content h1 {
              width: 110%;
            }
          }

          @media (max-width: 1200px) {
            .two_columns {
              padding: 20px;
            }
            .two_column_container {
              display: block;
            }
            .information_content {
              width: 100%;
              margin-top: 0;
            }
            .information_column {
              width: 100%;
              padding: 20px 0;
            }
            .information_content h1 {
              font-size: 26px;
              margin: 0;
            }
            .information_content h1,
            .information_content p {
              width: 100%;
            }
            .information_content p {
              margin-bottom: 0px !important;
            }
            .image_column {
              width: 100%;
              margin: 0 auto;
            }

            .icons_logos img {
              height: 40px;
            }
          }
        `}
      </style>
    </>
  );
};

export default TwoColumnsTab;
